import { Label } from "@/components/_Shared/Form/Label"
import { generic_input_css } from "./Utils/css"
import { UseFormRegister, FieldValues, Path } from "react-hook-form"

type TextAreaProps<TFormValues extends FieldValues> = {
    name: string
    label: string
    placeholder: string
    required?: boolean
    register: UseFormRegister<TFormValues>
}

export function TextArea<TFormValues extends FieldValues>(props: TextAreaProps<TFormValues>) {
    const {name, label, placeholder, required = false, register} = props

    return (
        <div className="grid w-full grid-cols-1 gap-2">
            <Label label={label} name={name} required={required}/>
            <textarea 
                id={name}
                placeholder={placeholder} 
                className={generic_input_css} 
                {...register(name as Path<TFormValues>)} 
                data-testid={name + "-textarea"}  
            />
        </div>
    )
}
